import { createContext } from 'react';

export type UrlContextType = {
  savedUrl: string;
  setSavedUrl: (newUrl: string) => void;
};

export const UrlContext = createContext<UrlContextType>({
  savedUrl: '',
  setSavedUrl: () => {}
});
